import React,{Fragment} from 'react';
import { connect } from 'react-redux';
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton'
import MdDelete from 'react-icons/lib/md/delete'
import { withRouter } from 'react-router-dom';
import * as actions from '../../Actions/index.js';

class CancelDokkit extends React.Component {

	state = {
		modalOpen: false,
		requesting: false
	}

	constructor(props) {
		super(props);
	}

	_toggleModal = () => {
		this.setState({
			modalOpen: !this.state.modalOpen
		})
	}

	_cancelDokkit = () => {
		const {companyUserId, companyId, cancelDokkit, removeDokkitList} = this.props;
		if(companyUserId){
			this.setState({
				requesting: true
			}, () => {
				cancelDokkit(companyUserId, "admin_company_listing")
				.then(() => {
					this.props.history.push(`/admin-dashboard`);
					removeDokkitList(companyId);					
				})
			})	

		}else{
			alert("Invalid dokkit account")
		}
	}

	render() {
		const {companyUserId} = this.props;
		const {requesting} = this.state

		if(!companyUserId){
			return null
		}

		const actions = [
          	<FlatButton 
			    label={`${requesting ? "Canceling...":"Confirm Cancellation"}`} 
			    secondary={true} 
			    className={'cancel-dokkit-button'}
			    icon={<MdDelete color="#e94731" />}
			    labelStyle={{'fontWeight': '600' , color: '#e94731'}}
			    style={{float:'left'}}
			    onClick={this._cancelDokkit}
			    disabled={requesting}
			/>,
			<RaisedButton
	            label="Cancel"
	            labelStyle={{'color': '#fff'}}
	            keyboardFocused={true}
	            onClick={this._toggleModal}
	            disabled={requesting}
	            disabledBackgroundColor={"rgb(229, 229, 229)"}
          	/>
        ];
		return (
			<Fragment>
				<Row className="display-flex padd30">
					 <Col md={12} className="text-right">
					    <FlatButton 
						    label="Cancel Dokkit" 
						    secondary={true} 
						    icon={<MdDelete color="#e94731" />}
						    labelStyle={{'fontWeight': '600' , color: '#e94731'}}
						    onClick={this._toggleModal}
						/>
	                </Col>

				</Row>
				<Dialog 
	                actions={actions}
	                className="model-support"
	                modal
	                contentClassName="model-top-overlay no-overlay"
	                open={ this.state.modalOpen}
	                onRequestClose={this._toggleModal}
	            > 
	                <div 
	                	style={{float: 'right',padding: '5px',margin: '-16px', cursor: 'pointer'}} 
	                	onClick={this._toggleModal} 
                	> 
                		<img src="/images/cross.svg"  alt="logo" />
            		</div>
		         	<div className="other-popup-content learn-more-popup">
		         	  	<div style={{'textAlign':'left'}}>
				          	<h3>Cancel Dokkit</h3>
				          	<p>
				          		If you cancel dokkit, related subscription, all jobs and O&M Manuals will be deleted. This can not be undone.
				          	</p>
			          	</div>
			       </div>
	    		</Dialog> 
			</Fragment> 
		)
	}
}

export default withRouter(connect(null,actions)(CancelDokkit));


// WEBPACK FOOTER //
// ./src/Components/Modules/CancelDokkit.js